var _circle, _g, _path, _rect, _rect2, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptySkills = function SvgEmptySkills(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 103,
    viewBox: "0 0 148 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.3856,
    cy: 51.2188,
    r: 51.2188,
    fill: "#262626",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4525_60227)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.7627,
    y: 21.9995,
    width: 132.476,
    height: 58.5357,
    rx: 6.16165,
    fill: "#FBFDFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5135 35.1665L25.4115 52.0889C24.8592 52.7517 24.583 53.083 24.5788 53.3629C24.5752 53.6062 24.6836 53.8377 24.8728 53.9906C25.0905 54.1665 25.5219 54.1665 26.3845 54.1665H37.9302L36.3468 66.8332L50.4489 49.9107C51.0011 49.248 51.2773 48.9166 51.2815 48.6368C51.2852 48.3935 51.1768 48.162 50.9875 48.0091C50.7698 47.8332 50.3385 47.8332 49.4758 47.8332H37.9302L39.5135 35.1665Z",
    stroke: "#262626",
    strokeOpacity: 0.6,
    strokeWidth: 1.54041,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73.615,
    y: 36.9712,
    width: 45.4422,
    height: 6.16165,
    rx: 3.08083,
    fill: "#262626",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73.615,
    y: 47.7539,
    width: 45.4422,
    height: 6.16165,
    rx: 3.08083,
    fill: "#262626",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.615,
    y: 58.5371,
    width: 45.4422,
    height: 6.16165,
    rx: 3.08083,
    fill: "#262626",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4525_60227",
    x: 0.0606279,
    y: 14.2974,
    width: 147.88,
    height: 73.9398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.85103
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4525_60227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4525_60227",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptySkills);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "emptySkills.61ee403496e48be073718db9461e1308.svg";